import "./assets/main.css"; // Import the main CSS file
import { createApp } from "vue"; // Import Vue's createApp function
import App from "./App.vue"; // Import the root component App
import "./components/index.css";

// Create and mount the Vue app
createApp(App).mount("#app");
